import { ITicker } from '@kattana-io/common';
import useTickerLivePrice from '../hooks/useTickerLivePrice';
import NumberDisplay from '../../../molecules/NumberDisplay';
import NumberAnimation from '../../../molecules/NumberAnimation';
import { getPriceChange } from '../../../helpers/priceChange';

interface IDailyPriceChangeMobile {
  ticker: ITicker;
}

const DailyPriceChangeMobile = ({ ticker }: IDailyPriceChangeMobile) => {
  const { price } = useTickerLivePrice(ticker);

  const { priceChangePercent } = getPriceChange(price.rawPrice, ticker);

  // Return nothing if price didn't changed
  if (priceChangePercent === 0) {
    return (
      <NumberDisplay
        value={price.rawPrice}
        round={2}
        startSymbol={price.sign}
        textProps={{ size: 14, className: 'text--grey-400 text--weight-500' }}
      />
    );
  }

  return (
    <div className='price__change_cell'>
      <NumberAnimation
        value={price.rawPrice}
        round={2}
        startSymbol={price.sign}
        textProps={{
          size: 14,
          className: `text--${
            priceChangePercent < 0 ? 'red-700' : 'green-600'
          } text--weight-500`,
        }}
      />
      <NumberDisplay
        value={priceChangePercent}
        round={2}
        endSymbol='%'
        textProps={{
          size: 12,
          className: `text--${
            priceChangePercent < 0 ? 'red-700' : 'green-600'
          } text--weight-400`,
        }}
      />
    </div>
  );
};

export default DailyPriceChangeMobile;
